<template>
    <a-spin :spinning="$store.state.singleVueLoading">
        <!-- <a-layout class="layout-admin">
            <a-layout>
                <a-layout class="layout-main">
                    <a-layout-content class="layout-content">
                        <router-view />
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </a-layout> -->
<!--        style="overflow-x: hidden;overflow-y: auto;height:100vh"-->
        <a-layout>
            <router-view />
        </a-layout>
    </a-spin>
</template>

<script>

export default {
    name: "index",
    components: {
    },
    data() {
        return {
            abs: true
        }
    },
    methods: {
        getmsg(val) {
            this.abs = val
        }
    },
}
</script>

<style scoped lang="less">
.layout-admin {
    height: 100vh;
    overflow: hidden;
    min-width: 1200px;
    min-height: 600px;
}

.layout-content {
    overflow-y: auto;
    padding: 10px;
}
</style>
